var app_support_table = $('#app-support-table');

if (app_support_table.length) {
    var issue_files_att = [];
    var table_support=   $('#app-support-table').DataTable({
        "processing": true,
        "serverSide": true,
        ajax: {
            url: '/support/index',
            dataSrc: 'data'
        },
        columns: [
            {data: 'id'},//0
            {data: 'ticket_number'},//1
            {data: 'agency_name'},//2
            {data: 'user_name'},//3
            {data: 'recurring'},//4
            {data: 'status'},//5
            {data: 'created_date'},//6
            {data: 'id'},//7
        ],
        "columnDefs": [
            {
                "targets": 0,
                //  "visible": false,
                "searchable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '<div class="checkbox checkbox-danger issues_check_div"> ' +
                            '<input class="checkbox" class="form-control" type="checkbox"  id="sel_ar_' + cellData + '" name="selected_issues_check[]" value="' + rowData.id + '" ><label for="sel_ar_' + cellData + '"> </label></div>';
                        $(td).html(html);

                }
            },
            {
                "targets": 7,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html = '<div class="row text-center" >' +
                        '<div class="btn-group" role="group">' +
                        '<button  class="btn btn-info btn-sm display_error " data-id="' + cellData + '">' +
                        '<i class="fa fa-eye"></i> Display' +
                        '</button>';
                    if (rowData.status === 'scheduled'){
                        html += '<button class="btn btn-success btn-sm change_status" data-id="' + cellData + '">' +
                            '<i class="fa fa-pencil"></i>Change Status' +
                            '</button>';
                     }
                    html+=  '</div>' +
                            '</div>';

                    $(td).html(html);

                }
            }],
        "createdRow": function (row, data, dataIndex) {
            $(row).attr('data-issue-id', data.id);
        }

    });

    $('#app-support-table').on('click', '.display_error', function () {
        show_loader();
        var id=$(this).attr('data-id');
        $.ajax({
            url: '/help/errors/support/getError/' + id,
            type:'GET',
            dataType: 'json',
            encode: true,
            success: function (response) {
                var data = response.issue;
                issue_files_att = response.att;
                console.log('data ...', response);
                var mod= '';
                for(var i in data.affected_modules) {
                    if (i == 0)
                        mod = data.affected_modules[i] ;
                    else
                        mod += ', '+data.affected_modules[i] ;
                }
                $('#issue_id_hidden').val(id);
                $('#ticket_number_title').html('Issue Number: '+data.ticket_number);
                $('#reported_by').val(data.user_name);
                $('#agency_name').val(data.agency_name);
                $('#created_at').val(moment(data.created_at).format('MMM DD , YYYY h:mmA'));
                $('#date_of_ocu').val(moment(data.date_occurrence).format('MMM DD, YYYY'));
                $('#time_of_occu').val(data.time_occurrence);
                $('#time_zone_').val(data.time_zone);
                $('#affect_mod').val(mod);
                $('#other_affect_mod').val(data.other_affected_feat);
                $('#url_prov').val(data.issue_url);
                $('#recurring').val((data.error_recurring === 1) ? 'Yes' : 'No');
                $('#iss_descrp').val(data.error_description);

               $('#DisplayError').modal('show');
               hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });
    });
    var table_support_attatchments;
    function InizializateFileTables(){
         table_support_attatchments=   $('#app-support-attachments-table').DataTable({
            columns: [
                {data: 'id'},//0
                {data: 'file_name'},//1
                {data: 'path'},//2
            ],
             destroy: true,
            "columnDefs": [
                {
                    "targets": 2,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '<div class="row text-center" >' +
                            '<div class="btn-group" role="group">' ;
                        html += '<button type="button" class="btn btn-info btn-outline btn-sm download_link" data-id="' + cellData + '" data-path="'+cellData+'"> ' +
                            '<i class="ti-download">  </i>Download' +
                            '</button>';

                        html+=  '</div>' +
                            '</div>';

                        $(td).html(html);

                    }
                }],
            "createdRow": function (row, data, dataIndex) {
                $(row).attr('data-issue-id', data.id);
            }

        });
        var data = [];
        for(var i in issue_files_att){
            data.push({
                id: parseInt(i) + 1,
                file_name:issue_files_att[i].original_name,
                path: issue_files_att[i].new_path,
            });
        }

        table_support_attatchments.clear();
        table_support_attatchments.rows.add(data);
        table_support_attatchments.draw();
    }
    $('#down_att_bu').on('click', function(){
        if(issue_files_att.length > 0){
            InizializateFileTables();
           $('#DownAttachmentIssue').modal('show');
       }
    });
    $('#select_all_issues').on('click', function (e) {
        $('#app-support-table input:checkbox').each(function () {
            $(this).prop('checked', true);
        });
    });
    $('#deselect_all_issues').on('click', function (e) {
        $('#app-support-table input:checkbox').prop('checked', false);
    });
    $('#change_status').on('click', function (e) {
        var selectedItems = [];
        $('.issues_check_div input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        if(selectedItems.length == 0){
            swal({
                    title: "Please select at least one Ticket",
                    text: "",
                    type: "warning",
                    //  showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    //cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                    }
                });
        }
        else{

        }
    });
   $('#app-support-attachments-table').on('click', '.download_link',function(e){
       var path = $(this).attr('data-path');
       var a = $("<a style='display: none;'/>");
       var url = path;
       a.attr("href", url);
       a.attr("download", 'test');
       $("body").append(a);
       a[0].click();
       window.URL.revokeObjectURL(url);
       a.remove();
   });

   $('#app-support-table').on('click', '.change_status', function () {
        var id=$(this).attr('data-id');
        swal({
                title: "Warning",
                text: "Are you sure to change Error Status?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader();
                    $.ajax({
                        url: '/help/errors/support/changeStatus/' + id,
                        type:'GET',
                        success: function (data) {
                            global_notification('success', 'Status changed...');
                            hide_loader();
                            table_support.clear();
                            table_support.rows.add(data);
                            table_support.draw();
                        },
                        error: function (xhr) {
                            ajax_error();
                            debug(xhr.responseText);
                            hide_loader();
                        }
                    });

                }
            });

    });
}
